import { useTranslation } from '@/services/i18n'
import { Button, Input, Select } from 'antd'
import React, { memo, useEffect, useState } from 'react'
import MyTable from '@/components/Table'
import styles from './index.module.scss'
import WalletButton from '@/components/WalletButton'
import { ReactComponent as AddWalletIcon } from '@/assets/icons/addWallet.svg'
import WhiteListDrawer from '../../components/WhiteListDrawer'
import { WhiteListAuditStatus } from '@/constants/enum'
import cls from 'classnames'

import base from '@/services/apis/base'
import { AddressBookModel, GetAddressBookListDTO } from '@/services/apis/policy/model'
import { ChainlistModel } from '@/services/apis/base/models'
import policy from '@/services/apis/policy'
import Modal from '@/components/Modal'
import {
  getWhiteListStatusText,
  queryRules,
  whiteListStatusColorClass,
} from '@/utils/whiteListUtils'
const { Search } = Input

const WhiteList = memo(() => {
  const { t } = useTranslation()
  const [item, setItem] = useState<AddressBookModel | undefined>(undefined)

  const [open, setOpen] = useState(false)

  const columns = [
    {
      title: t('whiteList.addressTitle'),
      key: 'blockchainTypeNodeId',
      render: (record: AddressBookModel) => {
        return (
          <div>
            <div>{record.addressName}</div>
            {record.auditStatus === WhiteListAuditStatus.MODIFIY && (
              <div style={{ fontSize: '13px', color: '#888E8E' }}>
                {t('whiteList.submitChanges')}
              </div>
            )}
          </div>
        )
      },
    },
    {
      title: t('record.txType'),
      dataIndex: 'blockchainTypeName',
    },
    {
      title: t('whiteList.address1'),
      dataIndex: 'address',
    },
    {
      title: t('txRecord.status'),
      key: 'blockchainTypeNodeId',
      render: (record: AddressBookModel) => {
        return (
          <div>
            <div
              className={cls(
                styles.status_dot,
                whiteListStatusColorClass(record.auditStatus as number, record.activeStatus)
              )}
            />
            {getWhiteListStatusText(record.auditStatus, record.activeStatus)}
          </div>
        )
      },
    },
    {
      title: t('common.operation'),
      key: 'blockchainTypeNodeId',
      render: (record: AddressBookModel) => {
        return (
          <div>
            <Button
              type="link"
              style={{ marginRight: '40px', fontWeight: '500' }}
              onClick={() => handleChange(record)}
              disabled={
                record.auditStatus === WhiteListAuditStatus.MODIFIY ||
                record.auditStatus === WhiteListAuditStatus.INAPPRVAL
              }
            >
              {t('common.change')}
            </Button>
            <Button type="link" style={{ fontWeight: '500' }} onClick={() => handleDel(record)}>
              {t('common.delete')}
            </Button>
          </div>
        )
      },
    },
  ]
  const enterButton = (
    <Button style={{ width: '90px', height: '40px' }} type="primary">
      {t('common.search')}
    </Button>
  )

  function handleChange(record: AddressBookModel) {
    // 复制一个对象传递，触发依赖变化
    setItem(Object.assign({}, record))
    setOpen(true)
  }
  function handleSelect(type: string, value: any) {
    if (type === 'blockchain') {
      setQueryParam({
        ...queryParam,
        blockchainTypeKey: value,
      })
    } else if (type === 'auditStatus') {
      setQueryParam({
        ...queryParam,
        auditStatus: value,
      })
    } else if (type === 'page') {
      setQueryParam({
        ...queryParam,
        page: value,
      })
      setCurrentPage(value)
    } else {
      setQueryParam({
        ...queryParam,
        queryStr: value,
        page: 1,
      })
      setCurrentPage(1)
    }
  }

  // 删除白名单
  async function handleDelWhite(addressBookModel: AddressBookModel) {
    // 查询是否有关联策略
    const { autoSweepRes, txRes } = await queryRules(addressBookModel.addressBookKey)
    // 有关联策略
    if (autoSweepRes.data || txRes.data) {
      Modal.info({
        title: t('whiteList.delWhiteInfo', {
          x: addressBookModel.addressName,
        }),

        content: null,
        okText: t('common.confirm'),
        wrapClassName: styles.delModal,
      })
      // 没有关联策略就删除
    } else {
      const res = await policy.delAddressBook({
        addressBookKey: addressBookModel.addressBookKey,
        timestamp: new Date().getTime(),
      })
      if (res.success) {
        getAddressBook(queryParam)
      }
    }
  }

  async function handleDel(record: AddressBookModel) {
    Modal.confirm({
      title: t('whiteList.delWhiteConfirm', { x: record.addressName }),
      content: null,
      okText: t('whiteList.delBtn'),
      wrapClassName: styles.delModal,
      onOk: () => handleDelWhite(record),
    })
  }
  // 存储链和白名单
  const [chainList, setChainList] = useState<ChainlistModel[]>([] as ChainlistModel[])
  const [addressBookList, setAddressBookList] = useState<AddressBookModel[]>(
    [] as AddressBookModel[]
  )
  const [addressBookCount, setAddressBookCount] = useState(0)
  // 白名单查询参数
  const [queryParam, setQueryParam] = useState<GetAddressBookListDTO>({
    blockchainTypeKey: '',
    queryStr: '',
    page: 1,
    pageSize: 50,
  })
  const [currentPage, setCurrentPage] = useState(1)
  // 获取链
  async function getBlockchainList() {
    const res = await base.getBlockchainList()
    setChainList(res.data)
  }
  const [tableLoading, setTableLoading] = useState(false)
  // 获取白名单

  async function getAddressBook(params: GetAddressBookListDTO) {
    setTableLoading(true)
    const res = await policy.getAddressBookList(params)
    const { data } = await policy.getAddressBookCount(params)
    setAddressBookList(res.data)
    setAddressBookCount(data)
    setTableLoading(false)
  }
  useEffect(() => {
    getBlockchainList()
  }, [])
  const [dep, setDep] = useState()
  useEffect(() => {
    getAddressBook(queryParam)
  }, [queryParam, dep])
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.left}>
          <Select
            style={{ width: 120, margin: '0 20px' }}
            options={[
              { value: '', label: t('policy.allType') },
              ...chainList.map(item => ({
                value: item.blockchainTypeKey,
                label: item.blockchainTypeName,
              })),
            ]}
            defaultValue=""
            onChange={val => handleSelect('blockchain', val)}
          />
          <Select
            style={{ width: 120 }}
            options={[
              { value: '', label: t('record.allStatus') },
              { value: 0, label: t('txRecord.pending') },
              { value: 1, label: t('policy.valid') },
              { value: 2, label: t('enum.apiStatus.Unapproved') },
            ]}
            defaultValue=""
            onChange={val => handleSelect('auditStatus', val)}
          />
          <Search
            placeholder={t('wallet.sendDrawer.tab2.placeholder') as string}
            enterButton={enterButton}
            size="small"
            style={{ width: '550px', marginLeft: '20px' }}
            onSearch={val => {
              handleSelect('queryStr', val)
            }}
            allowClear
          />
        </div>
        <div className={styles.right} style={{ marginRight: '20px' }}>
          <WalletButton
            text={t('whiteList.addWhiteList')}
            icon={<AddWalletIcon />}
            onClick={() => {
              setOpen(true)
              setItem(undefined)
            }}
          />
        </div>
      </div>
      <MyTable
        dataSource={addressBookList}
        columns={columns}
        style={{ height: 100 }}
        pagination={{
          pageSize: 50,
          showSizeChanger: false,
          onChange: page => handleSelect('page', page),
          hideOnSinglePage: true,
          total: addressBookCount,
          current: currentPage,
        }}
        bottomY={70}
        loading={tableLoading}
      />
      <WhiteListDrawer
        open={open}
        onClose={() => setOpen(false)}
        currentItem={item}
        chainList={chainList}
        getAddressBookList={setDep}
      />
    </div>
  )
})

export default WhiteList
